import { UsernameOnboardingModal } from '@/components/auth/UsernameOnboardingModal';
import { useUsernameOnboarding } from '@/hooks/useUsernameOnboarding';
import { useAuth } from '@/hooks/useAuth';

interface UsernameGateProps {
  children: React.ReactNode;
}

export function UsernameGate({ children }: UsernameGateProps) {
  const { user, isLoading: authLoading } = useAuth();
  const { needsUsername, isChecking, completeOnboarding } = useUsernameOnboarding();

  // Don't show modal while auth is loading
  if (authLoading || isChecking) {
    return <>{children}</>;
  }

  // Only show username modal if user is logged in but has no username
  const showUsernameModal = user && needsUsername;

  return (
    <>
      {children}
      <UsernameOnboardingModal 
        open={showUsernameModal || false} 
        onComplete={completeOnboarding} 
      />
    </>
  );
}
